import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "doc"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/** @jsx jsx */


import { Global } from '@emotion/core';
import { useConfig } from 'docz';
import { Header } from 'gatsby-theme-docz/src/components/Header';
import * as styles from 'gatsby-theme-docz/src/components/Layout/styles';
import { MainContainer } from 'gatsby-theme-docz/src/components/MainContainer';
import { Sidebar } from 'gatsby-theme-docz/src/components/Sidebar';
import { breakpoints } from 'gatsby-theme-docz/src/theme/breakpoints';
import { useRef, useState } from 'react';
import { Box, Flex, jsx } from 'theme-ui';
import useExtendedMenus from '../../hooks/useExtendedMenus';
import Footer from '../Footer';
import NavHeadings from '../NavHeadings';
import { Content, globalStyles } from './custom-styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Layout = function Layout(_ref) {
  var _ref3;

  var children = _ref.children,
      _ref$doc = _ref.doc,
      doc = _ref$doc === void 0 ? {} : _ref$doc,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useConfig = useConfig(),
      _useConfig$themeConfi = _useConfig.themeConfig.mainContainer;

  _useConfig$themeConfi = _useConfig$themeConfi === void 0 ? {} : _useConfig$themeConfi;
  var fullscreen = _useConfig$themeConfi.fullscreen,
      _useConfig$themeConfi2 = _useConfig$themeConfi.align,
      align = _useConfig$themeConfi2 === void 0 ? 'center' : _useConfig$themeConfi2;

  var _useState = useState(''),
      query = _useState[0],
      setQuery = _useState[1];

  var _useState2 = useState(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var ref = useRef();
  var menus = useExtendedMenus({
    query: query
  });

  var handleChange = function handleChange(ev) {
    setQuery(ev.target.value);
  };

  var _ref2 = doc.value || {},
      updated = _ref2.updated;

  var mainStyles = _objectSpread({
    marginLeft: align !== 'left' ? 'auto' : 0,
    marginRight: align !== 'right' ? 'auto' : 0
  }, fullscreen ? {
    maxWidth: 'none'
  } : undefined);

  return jsx(Flex, {
    sx: {
      '& > div': {
        flex: '1 1 auto'
      }
    },
    "data-testid": "layout"
  }, jsx(Global, {
    styles: globalStyles
  }), jsx(Box, {
    sx: styles.main
  }, jsx(Header, {
    onOpen: function onOpen() {
      return setOpen(function (s) {
        return !s;
      });
    }
  }), jsx("div", {
    sx: styles.wrapper
  }, jsx(Sidebar, {
    ref: ref,
    open: open,
    menus: menus,
    handleChange: handleChange,
    onFocus: function onFocus() {
      return setOpen(true);
    },
    onBlur: function onBlur() {
      return setOpen(false);
    },
    onClick: function onClick() {
      return setOpen(false);
    }
  }), jsx(MainContainer, _extends({
    style: mainStyles,
    "data-testid": "main-container",
    doc: doc
  }, rest), jsx(Flex, {
    sx: (_ref3 = {
      width: '100%',
      justifyContent: 'stretch'
    }, _ref3["@media screen and (max-width: " + breakpoints.desktop + "px)"] = {
      flexDirection: 'column'
    }, _ref3)
  }, jsx(Content, null, jsx("div", null, children), jsx(Footer, {
    updated: updated,
    menus: menus
  })), jsx(NavHeadings, null))))));
};

if (typeof Layout !== 'undefined' && Layout && Layout === Object(Layout) && Object.isExtensible(Layout) && !Object.prototype.hasOwnProperty.call(Layout, '__filemeta')) {
  Object.defineProperty(Layout, '__filemeta', {
    configurable: true,
    value: {
      name: "Layout",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Layout/index.js"
    }
  });
}